
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Upgrade',
    slotRoleSource: 'Your item',
    creditsAddLabel: 'Add coins from your balance',
    entryNeedsItem: 'Pick an item first',
    entryTotalLabel: 'Goes into the upgrade',
    entryItemPart: 'item',
    entryCreditsPart: 'coins',
    creditsClear: 'Remove',
    creditsBalance: 'Balance',
    creditsAll: 'All',
    slotRoleTarget: 'Target',
    price: 'Price',
    tryAgain: 'Try again',
    continueUpgrade: 'Upgrade again',
    faqHowItWorks: 'How it works?',
    history: 'History',
    topTitle: 'Top upgrades',
    topExplain: 'The biggest multipliers of winning upgrades. One best upgrade per player.',
    topPeriodDay: 'Today',
    topPeriodMonth: 'This month',
    topResetDay: 'A new top starts at 00:00 Moscow time',
    topResetMonth: 'A new top starts on {{date}} at 00:00 Moscow time',
    topYou: 'You',
    topYourPlace: 'place {{place}}',
    topEmptyDay: 'Nobody has won an upgrade today yet',
    topEmptyMonth: 'Nobody has won an upgrade this month yet',
    topError: 'Could not load the top',
    topChance: 'chance {{chance}}',
    historyEmpty: 'No upgrades yet',
    historyWin: 'Won',
    historyLoss: 'Lost',
    errorLoadHistory: 'Failed to load history',
    sell: 'Sell',
    confirmSellTitle: 'Confirm Sale',
    confirmSellMessage: 'Are you sure you want to sell {{item}} for {{price}}?',
    confirmSellCancel: 'Cancel',
    confirmSellConfirm: 'Sell',
    sellFailedTitle: 'Could not sell the item',
    selectSourceItem: 'Select item to upgrade',
    selectSourceFirst: 'Pick your item first',
    presetsLabel: 'Quick target',
    presetsEmpty: 'No matching target — try another option',
    orderCheapFirst: 'Cheapest first',
    orderPriceyFirst: 'Priciest first',
    selectTargetItem: 'Select target item',
    selectTarget: 'Select Item',
    searchTargets: 'Search by name',
    riskAll: 'All',
    riskSafe: 'Safe',
    riskMedium: 'Medium',
    riskRisky: 'Risky',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Failed to load available targets',
    slotRetry: 'Try again',
    errorLoadInventory: 'Failed to load inventory',
    noTargetsFound: 'No upgrade targets found',
    noSuitableItems: 'No items to upgrade',
    noSuitableItemsHint: 'Only items worth {{min}} coins or more can be upgraded. Open a case — the drop can go straight into an upgrade.',
    goToCases: 'To cases',
    failedTitle: 'No luck',
    upgradeFailedTitle: 'Upgrade did not go through',
    upgradeFailedItemUsed: 'This item has already gone into another upgrade. Inventory refreshed.',
    upgradeFailedItemGone: 'This item is no longer available for an upgrade. The list has been refreshed.',
    upgradeFailedPair: 'This pair does not work for an upgrade right now — pick another target.',
    upgradeFailedNoFunds: 'Not enough coins. Top up your balance and try again.',
    upgradeFailedHint: 'Try again in a minute.',
    share: 'Share',
    shareBigWin: 'Share the drop!',
    bigWinTitle: 'Big drop',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nLook what I got from an upgrade in SHOT!',
    shareCaptionBigWin: '🔥 <b>Big drop!</b>\n\n<b>{{itemName}}</b>\n\n\nLook what I got from an upgrade in SHOT!',
    shareButton: '🎮 Open SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'All',
    categoryAllItems: 'All items',
    categoryRifle: 'Rifles',
    categoryPistol: 'Pistols',
    categorySmg: 'SMGs',
    categoryHeavy: 'Heavy',
    categoryKnives: 'Knives',
    categoryGloves: 'Gloves',
    categoryEquipment: 'Equipment',
    categoryAgents: 'Agents',
    categoryStickers: 'Stickers',
    categoryPatches: 'Patches',
    categoryMusicKits: 'Music Kits',
    categoryKeychains: 'Keychains',
    categoryGraffiti: 'Graffiti',
  },
  ru: {
    screenTitle: 'Апгрейд',
    dialUpgrade: 'Улучшить',
    slotRoleSource: 'Твой предмет',
    creditsAddLabel: 'Добавить монеты с баланса',
    entryNeedsItem: 'Сначала выбери предмет',
    entryTotalLabel: 'В апгрейд уйдёт',
    entryItemPart: 'предмет',
    entryCreditsPart: 'монеты',
    creditsClear: 'Убрать',
    creditsBalance: 'На балансе',
    creditsAll: 'Всё',
    slotRoleTarget: 'Цель',
    price: 'Цена',
    tryAgain: 'Попробовать еще',
    continueUpgrade: 'Улучшить дальше',
    faqHowItWorks: 'Как это работает?',
    history: 'История',
    topTitle: 'Топ апгрейдов',
    topExplain: 'Самые большие множители выигранных апгрейдов. От каждого игрока — один лучший.',
    topPeriodDay: 'Сегодня',
    topPeriodMonth: 'Этот месяц',
    topResetDay: 'Новый топ — в 00:00 по Москве',
    topResetMonth: 'Новый топ — {{date}} в 00:00 по Москве',
    topYou: 'Ты',
    topYourPlace: '{{place}} место',
    topEmptyDay: 'Сегодня ещё никто не выиграл апгрейд',
    topEmptyMonth: 'В этом месяце ещё никто не выиграл апгрейд',
    topError: 'Не удалось загрузить топ',
    topChance: 'шанс {{chance}}',
    historyEmpty: 'Ты ещё ничего не улучшал',
    historyWin: 'Выигрыш',
    historyLoss: 'Сгорел',
    errorLoadHistory: 'Не удалось загрузить историю',
    sell: 'Продать',
    confirmSellTitle: 'Подтверждение продажи',
    confirmSellMessage: 'Продать {{item}} за {{price}}?',
    confirmSellCancel: 'Отмена',
    confirmSellConfirm: 'Продать',
    sellFailedTitle: 'Не получилось продать предмет',
    selectSourceItem: 'Выбери предмет для улучшения',
    selectSourceFirst: 'Сначала выбери свой предмет',
    presetsLabel: 'Подобрать цель',
    presetsEmpty: 'Подходящей цели нет — выбери другой вариант',
    orderCheapFirst: 'Сначала дешевле',
    orderPriceyFirst: 'Сначала дороже',
    selectTargetItem: 'Выбери целевой предмет',
    selectTarget: 'Выбор предмета',
    searchTargets: 'Поиск по названию',
    riskAll: 'Все',
    riskSafe: 'Надёжно',
    riskMedium: 'Средне',
    riskRisky: 'Риск',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Не удалось загрузить доступные цели',
    slotRetry: 'Повторить',
    errorLoadInventory: 'Не удалось загрузить инвентарь',
    noTargetsFound: 'Не найдено целей для улучшения',
    noSuitableItems: 'Нет предметов для апгрейда',
    noSuitableItemsHint: 'Улучшить можно предмет от {{min}} монет. Открой кейс — дроп можно сразу отправить в апгрейд.',
    goToCases: 'К кейсам',
    failedTitle: 'Не повезло',
    upgradeFailedTitle: 'Улучшение не прошло',
    upgradeFailedItemUsed: 'Этот предмет уже ушёл в другое улучшение. Инвентарь обновлён.',
    upgradeFailedItemGone: 'Предмет больше недоступен для улучшения. Список обновлён.',
    upgradeFailedPair: 'Эта пара сейчас не подходит для улучшения — выбери другую цель.',
    upgradeFailedNoFunds: 'Не хватает монет. Пополни баланс и попробуй снова.',
    upgradeFailedHint: 'Попробуй ещё раз через минуту.',
    share: 'Поделиться',
    shareBigWin: 'Поделиться дропом!',
    bigWinTitle: 'Крупный дроп',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nСмотри что мне выпало из улучшения в SHOT!',
    shareCaptionBigWin: '🔥 <b>Крупный дроп!</b>\n\n<b>{{itemName}}</b>\n\n\nСмотри что мне выпало из улучшения в SHOT!',
    shareButton: '🎮 Открыть SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Все',
    categoryAllItems: 'Все предметы',
    categoryRifle: 'Винтовки',
    categoryPistol: 'Пистолеты',
    categorySmg: 'ПП',
    categoryHeavy: 'Тяжелое',
    categoryKnives: 'Ножи',
    categoryGloves: 'Перчатки',
    categoryEquipment: 'Снаряжение',
    categoryAgents: 'Агенты',
    categoryStickers: 'Наклейки',
    categoryPatches: 'Нашивки',
    categoryMusicKits: 'Музыка',
    categoryKeychains: 'Брелоки',
    categoryGraffiti: 'Граффити',
  },
  uz: {
    screenTitle: 'Apgreyd',
    dialUpgrade: 'Yaxshilash',
    slotRoleSource: 'Buyuming',
    creditsAddLabel: 'Balansdan tanga qoʻshish',
    entryNeedsItem: 'Avval buyum tanla',
    entryTotalLabel: 'Apgreydga ketadi',
    entryItemPart: 'buyum',
    entryCreditsPart: 'tangalar',
    creditsClear: 'Olib tashlash',
    creditsBalance: 'Balansda',
    creditsAll: 'Hammasi',
    slotRoleTarget: 'Maqsad',
    price: 'Narx',
    tryAgain: 'Qayta urinish',
    continueUpgrade: 'Yana yaxshilash',
    faqHowItWorks: 'Bu qanday ishlaydi?',
    history: 'Tarix',
    topTitle: 'Eng yaxshi apgreydlar',
    topExplain: 'Yutgan apgreydlarning eng katta koʻpaytuvchilari. Har bir oʻyinchidan — bittadan eng yaxshisi.',
    topPeriodDay: 'Bugun',
    topPeriodMonth: 'Shu oy',
    topResetDay: 'Yangi top — Moskva vaqti bilan 00:00 da',
    topResetMonth: 'Yangi top — {{date}}, 00:00 (Moskva vaqti)',
    topYou: 'Sen',
    topYourPlace: '{{place}}-oʻrin',
    topEmptyDay: 'Bugun hali hech kim apgreydni yutmadi',
    topEmptyMonth: 'Bu oy hali hech kim apgreydni yutmadi',
    topError: 'Topni yuklab boʻlmadi',
    topChance: 'imkon {{chance}}',
    historyEmpty: 'Hali hech narsani yaxshilamagansan',
    historyWin: 'Yutuq',
    historyLoss: 'Yoʻqoldi',
    errorLoadHistory: 'Tarixni yuklab boʻlmadi',
    sell: 'Sotish',
    confirmSellTitle: 'Sotishni tasdiqlash',
    confirmSellMessage: '{{item}}ni {{price}}ga sotmoqchimisan?',
    confirmSellCancel: 'Bekor qilish',
    confirmSellConfirm: 'Sotish',
    sellFailedTitle: 'Buyumni sotib boʻlmadi',
    selectSourceItem: 'Yaxshilash uchun buyum tanla',
    selectSourceFirst: 'Avval buyumingni tanla',
    presetsLabel: 'Maqsadni tanlash',
    presetsEmpty: 'Mos maqsad yoʻq — boshqa variantni tanla',
    orderCheapFirst: 'Avval arzonlari',
    orderPriceyFirst: 'Avval qimmatlari',
    selectTargetItem: 'Maqsadli buyumni tanla',
    selectTarget: 'Buyumni tanlash',
    searchTargets: 'Nomi boʻyicha qidirish',
    riskAll: 'Barchasi',
    riskSafe: 'Ishonchli',
    riskMedium: 'Oʻrtacha',
    riskRisky: 'Xavfli',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Mavjud maqsadlarni yuklab boʻlmadi',
    slotRetry: 'Qayta urinish',
    errorLoadInventory: 'Inventarni yuklab boʻlmadi',
    noTargetsFound: 'Yaxshilash maqsadlari topilmadi',
    noSuitableItems: 'Apgreyd uchun buyum yoʻq',
    noSuitableItemsHint: 'Faqat {{min}} tangadan qimmat buyumni yaxshilash mumkin. Keys och — dropni darhol apgreydga yuborsa boʻladi.',
    goToCases: 'Keyslarga',
    failedTitle: 'Omad kelmadi',
    upgradeFailedTitle: 'Yaxshilash amalga oshmadi',
    upgradeFailedItemUsed: 'Bu buyum allaqachon boshqa yaxshilashga ketgan. Inventar yangilandi.',
    upgradeFailedItemGone: 'Bu buyum endi yaxshilash uchun mavjud emas. Roʻyxat yangilandi.',
    upgradeFailedPair: 'Bu juftlik hozir yaxshilashga toʻgʻri kelmaydi — boshqa maqsad tanla.',
    upgradeFailedNoFunds: 'Tanga yetarli emas. Balansni toʻldirib, qayta urinib koʻr.',
    upgradeFailedHint: 'Bir daqiqadan soʻng qayta urinib koʻr.',
    share: 'Ulashish',
    shareBigWin: 'Dropni ulashish!',
    bigWinTitle: 'Katta drop',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nSHOTʼda yaxshilashdan nima chiqdimi qarang!',
    shareCaptionBigWin: '🔥 <b>Katta drop!</b>\n\n<b>{{itemName}}</b>\n\n\nSHOTʼda yaxshilashdan nima chiqdimi qarang!',
    shareButton: '🎮 SHOTʼni ochish',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Barchasi',
    categoryAllItems: 'Barcha buyumlar',
    categoryRifle: 'Miltiqlar',
    categoryPistol: 'Toʻpponchalar',
    categorySmg: 'PP',
    categoryHeavy: 'Ogʻir',
    categoryKnives: 'Pichoqlar',
    categoryGloves: 'Qoʻlqoplar',
    categoryEquipment: 'Jihoz',
    categoryAgents: 'Agentlar',
    categoryStickers: 'Stikerlar',
    categoryPatches: 'Yamoqlar',
    categoryMusicKits: 'Musiqa',
    categoryKeychains: 'Breloklar',
    categoryGraffiti: 'Graffiti',
  },
  fa: {
    screenTitle: 'ارتقا',
    dialUpgrade: 'ارتقا',
    slotRoleSource: 'آیتم تو',
    creditsAddLabel: 'افزودن سکه از موجودی',
    entryNeedsItem: 'اول یک آیتم انتخاب کن',
    entryTotalLabel: 'به ارتقا می‌رود',
    entryItemPart: 'آیتم',
    entryCreditsPart: 'سکه',
    creditsClear: 'حذف',
    creditsBalance: 'موجودی',
    creditsAll: 'همه',
    slotRoleTarget: 'هدف',
    price: 'قیمت',
    tryAgain: 'دوباره تلاش کن',
    continueUpgrade: 'ادامه ارتقا',
    faqHowItWorks: 'چطور کار می‌کند؟',
    history: 'تاریخچه',
    topTitle: 'برترین ارتقاها',
    topExplain: 'بزرگ‌ترین ضریب‌های ارتقاهای برنده. از هر بازیکن — فقط بهترینش.',
    topPeriodDay: 'امروز',
    topPeriodMonth: 'این ماه',
    topResetDay: 'جدول جدید — ساعت ۰۰:۰۰ به وقت مسکو',
    topResetMonth: 'جدول جدید — {{date}} ساعت ۰۰:۰۰ به وقت مسکو',
    topYou: 'تو',
    topYourPlace: 'رتبه {{place}}',
    topEmptyDay: 'امروز هنوز کسی ارتقا نبرده',
    topEmptyMonth: 'این ماه هنوز کسی ارتقا نبرده',
    topError: 'بارگذاری جدول ممکن نشد',
    topChance: 'شانس {{chance}}',
    historyEmpty: 'هنوز چیزی ارتقا نداده‌ای',
    historyWin: 'برد',
    historyLoss: 'از دست رفت',
    errorLoadHistory: 'تاریخچه بارگذاری نشد',
    sell: 'بفروش',
    confirmSellTitle: 'تأیید فروش',
    confirmSellMessage: 'مطمئنی {{item}} را به {{price}} می‌فروشی؟',
    confirmSellCancel: 'بی‌خیال',
    confirmSellConfirm: 'بفروش',
    sellFailedTitle: 'آیتم فروخته نشد',
    selectSourceItem: 'آیتمی برای ارتقا انتخاب کن',
    selectSourceFirst: 'اول آیتم خودت را انتخاب کن',
    presetsLabel: 'انتخاب سریع هدف',
    presetsEmpty: 'هدف مناسبی نیست — گزینه دیگری را امتحان کن',
    orderCheapFirst: 'اول ارزان‌ترها',
    orderPriceyFirst: 'اول گران‌ترها',
    selectTargetItem: 'آیتم هدف را انتخاب کن',
    selectTarget: 'انتخاب آیتم',
    searchTargets: 'جستجو بر اساس نام',
    riskAll: 'همه',
    riskSafe: 'مطمئن',
    riskMedium: 'متوسط',
    riskRisky: 'پرریسک',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'هدف‌های موجود بارگذاری نشدند',
    slotRetry: 'تلاش مجدد',
    errorLoadInventory: 'انبار بارگذاری نشد',
    noTargetsFound: 'هدفی برای ارتقا پیدا نشد',
    noSuitableItems: 'آیتمی برای ارتقا نیست',
    noSuitableItemsHint: 'فقط آیتم‌های {{min}} سکه به بالا ارتقا می‌شوند. یک کیس باز کن — دراپ را می‌شود مستقیم ارتقا داد.',
    goToCases: 'به کیس‌ها',
    failedTitle: 'شانس نیاوردی',
    upgradeFailedTitle: 'ارتقا انجام نشد',
    upgradeFailedItemUsed: 'این آیتم در ارتقای دیگری رفته. انبار تازه شد.',
    upgradeFailedItemGone: 'این آیتم دیگر برای ارتقا در دسترس نیست. فهرست تازه شد.',
    upgradeFailedPair: 'این جفت الان برای ارتقا کار نمی‌کند — هدف دیگری انتخاب کن.',
    upgradeFailedNoFunds: 'سکه کافی نداری. موجودیت را شارژ کن و دوباره تلاش کن.',
    upgradeFailedHint: 'یک دقیقه دیگر دوباره تلاش کن.',
    share: 'اشتراک',
    shareBigWin: 'دراپت را نشان بده!',
    bigWinTitle: 'دراپ بزرگ',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nببین از یک ارتقا در SHOT چه گرفتم!',
    shareCaptionBigWin: '🔥 <b>دراپ بزرگ!</b>\n\n<b>{{itemName}}</b>\n\n\nببین از یک ارتقا در SHOT چه گرفتم!',
    shareButton: '🎮 باز کردن SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'همه',
    categoryAllItems: 'همه آیتم‌ها',
    categoryRifle: 'رایفل',
    categoryPistol: 'پیستول',
    categorySmg: 'اس‌ام‌جی',
    categoryHeavy: 'سنگین',
    categoryKnives: 'چاقو',
    categoryGloves: 'دستکش',
    categoryEquipment: 'تجهیزات',
    categoryAgents: 'ایجنت',
    categoryStickers: 'استیکر',
    categoryPatches: 'پچ',
    categoryMusicKits: 'پک موسیقی',
    categoryKeychains: 'آویز',
    categoryGraffiti: 'گرافیتی',
  },
  pt: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Melhorar',
    slotRoleSource: 'Seu item',
    creditsAddLabel: 'Adicionar moedas do saldo',
    entryNeedsItem: 'Escolha um item primeiro',
    entryTotalLabel: 'Vai para o upgrade',
    entryItemPart: 'item',
    entryCreditsPart: 'moedas',
    creditsClear: 'Remover',
    creditsBalance: 'Saldo',
    creditsAll: 'Tudo',
    slotRoleTarget: 'Alvo',
    price: 'Preço',
    tryAgain: 'Tentar de novo',
    continueUpgrade: 'Melhorar mais',
    faqHowItWorks: 'Como funciona?',
    history: 'Histórico',
    topTitle: 'Top upgrades',
    topExplain: 'Os maiores multiplicadores de upgrades vencedores. Um melhor upgrade por jogador.',
    topPeriodDay: 'Hoje',
    topPeriodMonth: 'Este mês',
    topResetDay: 'Novo top começa às 00:00 (horário de Moscou)',
    topResetMonth: 'Novo top começa em {{date}} às 00:00 (horário de Moscou)',
    topYou: 'Você',
    topYourPlace: '{{place}}º lugar',
    topEmptyDay: 'Ninguém ganhou um upgrade hoje ainda',
    topEmptyMonth: 'Ninguém ganhou um upgrade este mês ainda',
    topError: 'Não foi possível carregar o top',
    topChance: 'chance {{chance}}',
    historyEmpty: 'Você ainda não fez nenhum upgrade',
    historyWin: 'Ganhou',
    historyLoss: 'Perdeu',
    errorLoadHistory: 'Não deu para carregar o histórico',
    sell: 'Vender',
    confirmSellTitle: 'Confirmar venda',
    confirmSellMessage: 'Vender {{item}} por {{price}}?',
    confirmSellCancel: 'Cancelar',
    confirmSellConfirm: 'Vender',
    sellFailedTitle: 'Não deu para vender o item',
    selectSourceItem: 'Escolha o item para melhorar',
    selectSourceFirst: 'Escolha seu item primeiro',
    presetsLabel: 'Alvo rápido',
    presetsEmpty: 'Nenhum alvo adequado — tente outra opção',
    orderCheapFirst: 'Mais baratos primeiro',
    orderPriceyFirst: 'Mais caros primeiro',
    selectTargetItem: 'Escolha o item alvo',
    selectTarget: 'Escolher item',
    searchTargets: 'Buscar por nome',
    riskAll: 'Todos',
    riskSafe: 'Seguro',
    riskMedium: 'Médio',
    riskRisky: 'Arriscado',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Não deu para carregar os alvos disponíveis',
    slotRetry: 'Tentar de novo',
    errorLoadInventory: 'Não deu para carregar o inventário',
    noTargetsFound: 'Nenhum alvo de upgrade encontrado',
    noSuitableItems: 'Nenhum item para upgrade',
    noSuitableItemsHint: 'Só dá para melhorar itens a partir de {{min}} moedas. Abra uma caixa — o drop pode ir direto para o upgrade.',
    goToCases: 'Para as caixas',
    failedTitle: 'Sem sorte',
    upgradeFailedTitle: 'O upgrade não passou',
    upgradeFailedItemUsed: 'Esse item já foi para outro upgrade. Inventário atualizado.',
    upgradeFailedItemGone: 'O item não está mais disponível para upgrade. A lista foi atualizada.',
    upgradeFailedPair: 'Esse par não serve para upgrade agora — escolha outro alvo.',
    upgradeFailedNoFunds: 'Moedas insuficientes. Deposite e tente de novo.',
    upgradeFailedHint: 'Tente de novo em um minuto.',
    share: 'Compartilhar',
    shareBigWin: 'Compartilhe o drop!',
    bigWinTitle: 'Drop grande',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nOlha o que eu consegui num upgrade no SHOT!',
    shareCaptionBigWin: '🔥 <b>Drop grande!</b>\n\n<b>{{itemName}}</b>\n\n\nOlha o que eu consegui num upgrade no SHOT!',
    shareButton: '🎮 Abrir SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Todos',
    categoryAllItems: 'Todos os itens',
    categoryRifle: 'Rifles',
    categoryPistol: 'Pistolas',
    categorySmg: 'SMGs',
    categoryHeavy: 'Pesadas',
    categoryKnives: 'Facas',
    categoryGloves: 'Luvas',
    categoryEquipment: 'Equipamento',
    categoryAgents: 'Agentes',
    categoryStickers: 'Adesivos',
    categoryPatches: 'Patches',
    categoryMusicKits: 'Músicas',
    categoryKeychains: 'Chaveiros',
    categoryGraffiti: 'Grafite',
  },
  tr: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Yükselt',
    slotRoleSource: 'Senin eşyan',
    creditsAddLabel: 'Bakiyeden coin ekle',
    entryNeedsItem: 'Önce bir eşya seç',
    entryTotalLabel: 'Upgrade’e gider',
    entryItemPart: 'eşya',
    entryCreditsPart: 'coin',
    creditsClear: 'Kaldır',
    creditsBalance: 'Bakiye',
    creditsAll: 'Hepsi',
    slotRoleTarget: 'Hedef',
    price: 'Fiyat',
    tryAgain: 'Tekrar dene',
    continueUpgrade: 'Yükseltmeye devam et',
    faqHowItWorks: 'Nasıl çalışır?',
    history: 'Geçmiş',
    topTitle: 'En iyi upgrade’ler',
    topExplain: 'Kazanan upgrade’lerin en büyük çarpanları. Her oyuncudan en iyi bir tane.',
    topPeriodDay: 'Bugün',
    topPeriodMonth: 'Bu ay',
    topResetDay: 'Yeni liste Moskova saatiyle 00:00’da başlar',
    topResetMonth: 'Yeni liste {{date}} Moskova saatiyle 00:00’da başlar',
    topYou: 'Sen',
    topYourPlace: '{{place}}. sıra',
    topEmptyDay: 'Bugün henüz kimse upgrade kazanmadı',
    topEmptyMonth: 'Bu ay henüz kimse upgrade kazanmadı',
    topError: 'Liste yüklenemedi',
    topChance: 'şans {{chance}}',
    historyEmpty: 'Henüz hiç upgrade yapmadın',
    historyWin: 'Kazandın',
    historyLoss: 'Yandı',
    errorLoadHistory: 'Geçmiş yüklenemedi',
    sell: 'Sat',
    confirmSellTitle: 'Satışı onayla',
    confirmSellMessage: '{{item}} {{price}} karşılığında satılsın mı?',
    confirmSellCancel: 'İptal',
    confirmSellConfirm: 'Sat',
    sellFailedTitle: 'Eşya satılamadı',
    selectSourceItem: 'Yükseltilecek eşyayı seç',
    selectSourceFirst: 'Önce eşyanı seç',
    presetsLabel: 'Hızlı hedef',
    presetsEmpty: 'Uygun hedef yok — başka bir seçenek dene',
    orderCheapFirst: 'Önce ucuzlar',
    orderPriceyFirst: 'Önce pahalılar',
    selectTargetItem: 'Hedef eşyayı seç',
    selectTarget: 'Eşya seç',
    searchTargets: 'İsme göre ara',
    riskAll: 'Tümü',
    riskSafe: 'Güvenli',
    riskMedium: 'Orta',
    riskRisky: 'Riskli',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Uygun hedefler yüklenemedi',
    slotRetry: 'Tekrar dene',
    errorLoadInventory: 'Envanter yüklenemedi',
    noTargetsFound: 'Upgrade için hedef bulunamadı',
    noSuitableItems: 'Upgrade için eşya yok',
    noSuitableItemsHint: "Sadece {{min}} coin ve üzeri eşyalar yükseltilebilir. Kasa aç — drop doğrudan upgrade'e gönderilebilir.",
    goToCases: 'Kasalara',
    failedTitle: 'Şans yok',
    upgradeFailedTitle: 'Upgrade geçmedi',
    upgradeFailedItemUsed: "Bu eşya zaten başka bir upgrade'e gitti. Envanter yenilendi.",
    upgradeFailedItemGone: 'Eşya artık upgrade için uygun değil. Liste yenilendi.',
    upgradeFailedPair: 'Bu ikili şu an upgrade için uygun değil — başka bir hedef seç.',
    upgradeFailedNoFunds: 'Yeterli coin yok. Bakiye yükle ve tekrar dene.',
    upgradeFailedHint: 'Bir dakika sonra tekrar dene.',
    share: 'Paylaş',
    shareBigWin: 'Dropu paylaş!',
    bigWinTitle: 'Büyük drop',
    shareCaption: "🎉 <b>{{itemName}}</b>\n\n\nBak SHOT'ta upgrade'den ne düştü!",
    shareCaptionBigWin: "🔥 <b>Büyük drop!</b>\n\n<b>{{itemName}}</b>\n\n\nBak SHOT'ta upgrade'den ne düştü!",
    shareButton: "🎮 SHOT'u aç",
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Tümü',
    categoryAllItems: 'Tüm eşyalar',
    categoryRifle: 'Tüfekler',
    categoryPistol: 'Tabancalar',
    categorySmg: 'SMG',
    categoryHeavy: 'Ağır',
    categoryKnives: 'Bıçaklar',
    categoryGloves: 'Eldivenler',
    categoryEquipment: 'Ekipman',
    categoryAgents: 'Ajanlar',
    categoryStickers: 'Çıkartmalar',
    categoryPatches: 'Yamalar',
    categoryMusicKits: 'Müzik',
    categoryKeychains: 'Anahtarlıklar',
    categoryGraffiti: 'Grafiti',
  },
  uk: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Покращити',
    slotRoleSource: 'Твій предмет',
    creditsAddLabel: 'Додати монети з балансу',
    entryNeedsItem: 'Спершу обери предмет',
    entryTotalLabel: 'В апгрейд піде',
    entryItemPart: 'предмет',
    entryCreditsPart: 'монети',
    creditsClear: 'Прибрати',
    creditsBalance: 'На балансі',
    creditsAll: 'Усе',
    slotRoleTarget: 'Ціль',
    price: 'Ціна',
    tryAgain: 'Спробувати ще',
    continueUpgrade: 'Покращити далі',
    faqHowItWorks: 'Як це працює?',
    history: 'Історія',
    topTitle: 'Топ апгрейдів',
    topExplain: 'Найбільші множники виграних апгрейдів. Від кожного гравця — один найкращий.',
    topPeriodDay: 'Сьогодні',
    topPeriodMonth: 'Цей місяць',
    topResetDay: 'Новий топ — о 00:00 за Москвою',
    topResetMonth: 'Новий топ — {{date}} о 00:00 за Москвою',
    topYou: 'Ти',
    topYourPlace: '{{place}} місце',
    topEmptyDay: 'Сьогодні ще ніхто не виграв апгрейд',
    topEmptyMonth: 'Цього місяця ще ніхто не виграв апгрейд',
    topError: 'Не вдалося завантажити топ',
    topChance: 'шанс {{chance}}',
    historyEmpty: 'Ти ще нічого не покращував',
    historyWin: 'Виграш',
    historyLoss: 'Згорів',
    errorLoadHistory: 'Не вдалося завантажити історію',
    sell: 'Продати',
    confirmSellTitle: 'Підтвердження продажу',
    confirmSellMessage: 'Продати {{item}} за {{price}}?',
    confirmSellCancel: 'Скасувати',
    confirmSellConfirm: 'Продати',
    sellFailedTitle: 'Не вдалося продати предмет',
    selectSourceItem: 'Обери предмет для покращення',
    selectSourceFirst: 'Спершу обери свій предмет',
    presetsLabel: 'Підібрати ціль',
    presetsEmpty: 'Підходящої цілі немає — обери інший варіант',
    orderCheapFirst: 'Спочатку дешевші',
    orderPriceyFirst: 'Спочатку дорожчі',
    selectTargetItem: 'Обери цільовий предмет',
    selectTarget: 'Вибір предмета',
    searchTargets: 'Пошук за назвою',
    riskAll: 'Усі',
    riskSafe: 'Надійно',
    riskMedium: 'Середньо',
    riskRisky: 'Ризик',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Не вдалося завантажити доступні цілі',
    slotRetry: 'Повторити',
    errorLoadInventory: 'Не вдалося завантажити інвентар',
    noTargetsFound: 'Цілей для покращення не знайдено',
    noSuitableItems: 'Немає предметів для апгрейду',
    noSuitableItemsHint: 'Покращити можна предмет від {{min}} монет. Відкрий кейс — дроп можна одразу відправити в апгрейд.',
    goToCases: 'До кейсів',
    failedTitle: 'Не пощастило',
    upgradeFailedTitle: 'Покращення не відбулося',
    upgradeFailedItemUsed: 'Цей предмет уже пішов в інше покращення. Інвентар оновлено.',
    upgradeFailedItemGone: 'Предмет більше недоступний для покращення. Список оновлено.',
    upgradeFailedPair: 'Ця пара зараз не підходить для покращення — обери іншу ціль.',
    upgradeFailedNoFunds: 'Не вистачає монет. Поповни баланс і спробуй знову.',
    upgradeFailedHint: 'Спробуй ще раз через хвилину.',
    share: 'Поділитися',
    shareBigWin: 'Поділитися дропом!',
    bigWinTitle: 'Крупний дроп',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nДивись, що мені випало з апгрейду в SHOT!',
    shareCaptionBigWin: '🔥 <b>Крупний дроп!</b>\n\n<b>{{itemName}}</b>\n\n\nДивись, що мені випало з апгрейду в SHOT!',
    shareButton: '🎮 Відкрити SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Усі',
    categoryAllItems: 'Усі предмети',
    categoryRifle: 'Гвинтівки',
    categoryPistol: 'Пістолети',
    categorySmg: 'ПК',
    categoryHeavy: 'Важка зброя',
    categoryKnives: 'Ножі',
    categoryGloves: 'Рукавиці',
    categoryEquipment: 'Спорядження',
    categoryAgents: 'Агенти',
    categoryStickers: 'Наліпки',
    categoryPatches: 'Нашивки',
    categoryMusicKits: 'Музичні альбоми',
    categoryKeychains: 'Брелоки',
    categoryGraffiti: 'Графіті',
  },
  de: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Upgraden',
    slotRoleSource: 'Dein Item',
    creditsAddLabel: 'Münzen vom Guthaben hinzufügen',
    entryNeedsItem: 'Wähle zuerst ein Item',
    entryTotalLabel: 'Ins Upgrade geht',
    entryItemPart: 'Item',
    entryCreditsPart: 'Münzen',
    creditsClear: 'Entfernen',
    creditsBalance: 'Guthaben',
    creditsAll: 'Alles',
    slotRoleTarget: 'Ziel',
    price: 'Preis',
    tryAgain: 'Nochmal versuchen',
    continueUpgrade: 'Weiter upgraden',
    faqHowItWorks: 'Wie funktioniert das?',
    history: 'Verlauf',
    topTitle: 'Top-Upgrades',
    topExplain: 'Die höchsten Multiplikatoren gewonnener Upgrades. Pro Spieler zählt nur das beste.',
    topPeriodDay: 'Heute',
    topPeriodMonth: 'Dieser Monat',
    topResetDay: 'Neues Top um 00:00 Moskauer Zeit',
    topResetMonth: 'Neues Top am {{date}} um 00:00 Moskauer Zeit',
    topYou: 'Du',
    topYourPlace: 'Platz {{place}}',
    topEmptyDay: 'Heute hat noch niemand ein Upgrade gewonnen',
    topEmptyMonth: 'Diesen Monat hat noch niemand ein Upgrade gewonnen',
    topError: 'Top konnte nicht geladen werden',
    topChance: 'Chance {{chance}}',
    historyEmpty: 'Du hast noch nichts aufgewertet',
    historyWin: 'Gewonnen',
    historyLoss: 'Verloren',
    errorLoadHistory: 'Verlauf konnte nicht geladen werden',
    sell: 'Verkaufen',
    confirmSellTitle: 'Verkauf bestätigen',
    confirmSellMessage: '{{item}} für {{price}} verkaufen?',
    confirmSellCancel: 'Abbrechen',
    confirmSellConfirm: 'Verkaufen',
    sellFailedTitle: 'Item konnte nicht verkauft werden',
    selectSourceItem: 'Item zum Aufwerten wählen',
    selectSourceFirst: 'Wähle zuerst dein Item',
    presetsLabel: 'Ziel vorschlagen',
    presetsEmpty: 'Kein passendes Ziel – probier eine andere Option',
    orderCheapFirst: 'Günstigste zuerst',
    orderPriceyFirst: 'Teuerste zuerst',
    selectTargetItem: 'Ziel-Item wählen',
    selectTarget: 'Item wählen',
    searchTargets: 'Nach Name suchen',
    riskAll: 'Alle',
    riskSafe: 'Sicher',
    riskMedium: 'Mittel',
    riskRisky: 'Riskant',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Verfügbare Ziele konnten nicht geladen werden',
    slotRetry: 'Nochmal versuchen',
    errorLoadInventory: 'Inventar konnte nicht geladen werden',
    noTargetsFound: 'Keine Upgrade-Ziele gefunden',
    noSuitableItems: 'Keine Items für ein Upgrade',
    noSuitableItemsHint: 'Aufgewertet werden können nur Items ab {{min}} Münzen. Öffne einen Case – der Drop kann direkt ins Upgrade gehen.',
    goToCases: 'Zu den Cases',
    failedTitle: 'Pech gehabt',
    upgradeFailedTitle: 'Upgrade nicht durchgegangen',
    upgradeFailedItemUsed: 'Dieses Item steckt schon in einem anderen Upgrade. Inventar aktualisiert.',
    upgradeFailedItemGone: 'Dieses Item ist für ein Upgrade nicht mehr verfügbar. Die Liste wurde aktualisiert.',
    upgradeFailedPair: 'Diese Kombination funktioniert gerade nicht für ein Upgrade – wähle ein anderes Ziel.',
    upgradeFailedNoFunds: 'Nicht genug Münzen. Lade dein Guthaben auf und versuch es nochmal.',
    upgradeFailedHint: 'Versuch es in einer Minute nochmal.',
    share: 'Teilen',
    shareBigWin: 'Drop teilen!',
    bigWinTitle: 'Großer Drop',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nSchau, was ich aus einem Upgrade in SHOT bekommen habe!',
    shareCaptionBigWin: '🔥 <b>Großer Drop!</b>\n\n<b>{{itemName}}</b>\n\n\nSchau, was ich aus einem Upgrade in SHOT bekommen habe!',
    shareButton: '🎮 SHOT öffnen',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Alle',
    categoryAllItems: 'Alle Items',
    categoryRifle: 'Gewehre',
    categoryPistol: 'Pistolen',
    categorySmg: 'MPs',
    categoryHeavy: 'Schwer',
    categoryKnives: 'Messer',
    categoryGloves: 'Handschuhe',
    categoryEquipment: 'Ausrüstung',
    categoryAgents: 'Agenten',
    categoryStickers: 'Aufkleber',
    categoryPatches: 'Aufnäher',
    categoryMusicKits: 'Musikkits',
    categoryKeychains: 'Anhänger',
    categoryGraffiti: 'Graffiti',
  },
  es: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Mejorar',
    slotRoleSource: 'Tu objeto',
    creditsAddLabel: 'Añadir monedas del saldo',
    entryNeedsItem: 'Primero elige un objeto',
    entryTotalLabel: 'Entra en el upgrade',
    entryItemPart: 'objeto',
    entryCreditsPart: 'monedas',
    creditsClear: 'Quitar',
    creditsBalance: 'En el saldo',
    creditsAll: 'Todo',
    slotRoleTarget: 'Objetivo',
    price: 'Precio',
    tryAgain: 'Intentar de nuevo',
    continueUpgrade: 'Seguir mejorando',
    faqHowItWorks: '¿Cómo funciona?',
    history: 'Historial',
    topTitle: 'Top de upgrades',
    topExplain: 'Los multiplicadores más altos de upgrades ganados. De cada jugador cuenta solo el mejor.',
    topPeriodDay: 'Hoy',
    topPeriodMonth: 'Este mes',
    topResetDay: 'Nuevo top a las 00:00, hora de Moscú',
    topResetMonth: 'Nuevo top el {{date}} a las 00:00, hora de Moscú',
    topYou: 'Tú',
    topYourPlace: 'puesto {{place}}',
    topEmptyDay: 'Hoy todavía nadie ha ganado un upgrade',
    topEmptyMonth: 'Este mes todavía nadie ha ganado un upgrade',
    topError: 'No se pudo cargar el top',
    topChance: 'probabilidad {{chance}}',
    historyEmpty: 'Aún no has mejorado nada',
    historyWin: 'Ganado',
    historyLoss: 'Perdido',
    errorLoadHistory: 'No se pudo cargar el historial',
    sell: 'Vender',
    confirmSellTitle: 'Confirmar venta',
    confirmSellMessage: '¿Vender {{item}} por {{price}}?',
    confirmSellCancel: 'Cancelar',
    confirmSellConfirm: 'Vender',
    sellFailedTitle: 'No se pudo vender el objeto',
    selectSourceItem: 'Elige un objeto para mejorar',
    selectSourceFirst: 'Primero elige tu objeto',
    presetsLabel: 'Elegir objetivo',
    presetsEmpty: 'No hay un objetivo adecuado: prueba otra opción',
    orderCheapFirst: 'Primero los más baratos',
    orderPriceyFirst: 'Primero los más caros',
    selectTargetItem: 'Elige el objeto objetivo',
    selectTarget: 'Elegir objeto',
    searchTargets: 'Buscar por nombre',
    riskAll: 'Todos',
    riskSafe: 'Seguro',
    riskMedium: 'Medio',
    riskRisky: 'Arriesgado',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'No se pudieron cargar los objetivos disponibles',
    slotRetry: 'Reintentar',
    errorLoadInventory: 'No se pudo cargar el inventario',
    noTargetsFound: 'No se encontraron objetivos para mejorar',
    noSuitableItems: 'No hay objetos para un upgrade',
    noSuitableItemsHint: 'Solo se pueden mejorar objetos de {{min}} monedas o más. Abre una caja: el drop puede ir directo a un upgrade.',
    goToCases: 'A las cajas',
    failedTitle: 'Mala suerte',
    upgradeFailedTitle: 'El upgrade no se realizó',
    upgradeFailedItemUsed: 'Este objeto ya se usó en otro upgrade. Inventario actualizado.',
    upgradeFailedItemGone: 'Este objeto ya no está disponible para un upgrade. La lista se ha actualizado.',
    upgradeFailedPair: 'Esta combinación no sirve ahora para un upgrade: elige otro objetivo.',
    upgradeFailedNoFunds: 'No tienes monedas suficientes. Recarga tu saldo e inténtalo de nuevo.',
    upgradeFailedHint: 'Inténtalo de nuevo en un minuto.',
    share: 'Compartir',
    shareBigWin: '¡Comparte el drop!',
    bigWinTitle: 'Gran drop',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\n¡Mira lo que me ha tocado de un upgrade en SHOT!',
    shareCaptionBigWin: '🔥 <b>¡Gran drop!</b>\n\n<b>{{itemName}}</b>\n\n\n¡Mira lo que me ha tocado de un upgrade en SHOT!',
    shareButton: '🎮 Abrir SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Todos',
    categoryAllItems: 'Todos los objetos',
    categoryRifle: 'Rifles',
    categoryPistol: 'Pistolas',
    categorySmg: 'Subfusiles',
    categoryHeavy: 'Armas pesadas',
    categoryKnives: 'Cuchillos',
    categoryGloves: 'Guantes',
    categoryEquipment: 'Equipo',
    categoryAgents: 'Agentes',
    categoryStickers: 'Pegatinas',
    categoryPatches: 'Parches',
    categoryMusicKits: 'Kits de música',
    categoryKeychains: 'Llaveros',
    categoryGraffiti: 'Grafitis',
  },
  pl: {
    screenTitle: 'Upgrade',
    dialUpgrade: 'Ulepsz',
    slotRoleSource: 'Twój przedmiot',
    creditsAddLabel: 'Dodaj monety z salda',
    entryNeedsItem: 'Najpierw wybierz przedmiot',
    entryTotalLabel: 'Do upgrade’u pójdzie',
    entryItemPart: 'przedmiot',
    entryCreditsPart: 'monety',
    creditsClear: 'Usuń',
    creditsBalance: 'Na saldzie',
    creditsAll: 'Wszystko',
    slotRoleTarget: 'Cel',
    price: 'Cena',
    tryAgain: 'Spróbuj jeszcze raz',
    continueUpgrade: 'Ulepszaj dalej',
    faqHowItWorks: 'Jak to działa?',
    history: 'Historia',
    topTitle: 'Top upgrade’ów',
    topExplain: 'Największe mnożniki wygranych upgrade’ów. Od każdego gracza — jeden najlepszy.',
    topPeriodDay: 'Dzisiaj',
    topPeriodMonth: 'Ten miesiąc',
    topResetDay: 'Nowy top o 00:00 czasu moskiewskiego',
    topResetMonth: 'Nowy top {{date}} o 00:00 czasu moskiewskiego',
    topYou: 'Ty',
    topYourPlace: 'miejsce {{place}}',
    topEmptyDay: 'Dzisiaj nikt jeszcze nie wygrał upgrade’u',
    topEmptyMonth: 'W tym miesiącu nikt jeszcze nie wygrał upgrade’u',
    topError: 'Nie udało się wczytać topu',
    topChance: 'szansa {{chance}}',
    historyEmpty: 'Brak ulepszeń',
    historyWin: 'Wygrana',
    historyLoss: 'Przepadł',
    errorLoadHistory: 'Nie udało się wczytać historii',
    sell: 'Sprzedaj',
    confirmSellTitle: 'Potwierdzenie sprzedaży',
    confirmSellMessage: 'Sprzedać {{item}} za {{price}}?',
    confirmSellCancel: 'Anuluj',
    confirmSellConfirm: 'Sprzedaj',
    sellFailedTitle: 'Nie udało się sprzedać przedmiotu',
    selectSourceItem: 'Wybierz przedmiot do ulepszenia',
    selectSourceFirst: 'Najpierw wybierz swój przedmiot',
    presetsLabel: 'Dobierz cel',
    presetsEmpty: 'Brak pasującego celu — wybierz inną opcję',
    orderCheapFirst: 'Najpierw tańsze',
    orderPriceyFirst: 'Najpierw droższe',
    selectTargetItem: 'Wybierz przedmiot docelowy',
    selectTarget: 'Wybór przedmiotu',
    searchTargets: 'Szukaj po nazwie',
    riskAll: 'Wszystkie',
    riskSafe: 'Pewnie',
    riskMedium: 'Średnio',
    riskRisky: 'Ryzykownie',
    orderChance: '%',
    orderMultiplier: '×',
    errorLoadTargets: 'Nie udało się wczytać dostępnych celów',
    slotRetry: 'Spróbuj ponownie',
    errorLoadInventory: 'Nie udało się wczytać ekwipunku',
    noTargetsFound: 'Nie znaleziono celów do ulepszenia',
    noSuitableItems: 'Brak przedmiotów do upgrade’u',
    noSuitableItemsHint: 'Ulepszyć można przedmiot od {{min}} monet. Otwórz skrzynkę — drop można od razu wysłać do upgrade’u.',
    goToCases: 'Do skrzynek',
    failedTitle: 'Nie poszczęściło się',
    upgradeFailedTitle: 'Upgrade się nie udał',
    upgradeFailedItemUsed: 'Ten przedmiot poszedł już do innego upgrade’u. Ekwipunek odświeżony.',
    upgradeFailedItemGone: 'Ten przedmiot nie jest już dostępny do upgrade’u. Lista została odświeżona.',
    upgradeFailedPair: 'Ta para teraz nie nadaje się do upgrade’u — wybierz inny cel.',
    upgradeFailedNoFunds: 'Brakuje monet. Doładuj saldo i spróbuj ponownie.',
    upgradeFailedHint: 'Spróbuj ponownie za minutę.',
    share: 'Udostępnij',
    shareBigWin: 'Pochwal się dropem!',
    bigWinTitle: 'Wielki drop',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nZobacz, co wypadło mi z upgrade’u w SHOT!',
    shareCaptionBigWin: '🔥 <b>Wielki drop!</b>\n\n<b>{{itemName}}</b>\n\n\nZobacz, co wypadło mi z upgrade’u w SHOT!',
    shareButton: '🎮 Otwórz SHOT',
    shareFallback: '{{itemName}} — SHOT',
    categoryAll: 'Wszystkie',
    categoryAllItems: 'Wszystkie przedmioty',
    categoryRifle: 'Karabiny',
    categoryPistol: 'Pistolety',
    categorySmg: 'PM-y',
    categoryHeavy: 'Ciężkie',
    categoryKnives: 'Noże',
    categoryGloves: 'Rękawice',
    categoryEquipment: 'Wyposażenie',
    categoryAgents: 'Agenci',
    categoryStickers: 'Naklejki',
    categoryPatches: 'Naszywki',
    categoryMusicKits: 'Zestawy utworów',
    categoryKeychains: 'Breloki',
    categoryGraffiti: 'Graffiti',
  },
});
